import { ListItemIcon, Tooltip, Typography } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { useState } from 'react'

import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../../helpers/date'
import { lang } from '../../../localization'
import { ComLog } from '../../../types/monitoring'
import MonitoringFormViewMoreInfoModal from '../MonitoringFormViewMoreInfoModal'
import MonitoringRowMenu from '../MonitoringRowMenu'
import useStyles from './styles/MonitoringFormListRow.styles'

interface MonitoringFormListRowDesktopProps {
  data: ComLog
}
const MonitoringFormListRowDesktop: React.FC<
  MonitoringFormListRowDesktopProps
> = ({ data }) => {
  const classes = useStyles()
  const [viewRequestIsOpen, setviewRequestIsOpen] = useState<boolean>(false)
  const [viewResponseIsopen, setviewResponseIsopen] = useState<boolean>(false)
  //

  return (
    <div className={classes.root}>
      <div>
        <Typography className={classes.text} align="left">
          {lang === 'fa'
            ? gregorianToJalaaliWithHourMinuteAndSecond(data.Date)
            : data.Date}
        </Typography>
      </div>
      <div>
        <Tooltip title={data.UserId || ''} placement="top">
          <Typography className={classes.text} align="left">
            {data.UserId}
          </Typography>
        </Tooltip>
      </div>
      <div>
        <Typography className={classes.text} align="left">
          {data.UserIP}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text} align="left">
          {JSON.parse(data.Request).Method}
        </Typography>
      </div>
      <div className={classes.endpointURLSection}>
        <Typography className={classes.text} align="left">
          {data.EndpointName.length < 25
            ? data.EndpointName
            : `${data.EndpointName.substr(0, 25)} ...`}
        </Typography>
        <Tooltip
          className={classes.tooltipSection}
          placement="right"
          title={data.EndpointName}
          aria-label="EndpointName">
          <ListItemIcon>
            <InfoOutlinedIcon />
          </ListItemIcon>
        </Tooltip>
      </div>
      <div className={classes.endpointURLSection}>
        <Typography className={classes.text} align="left">
          {data.EndpointURL.length < 25
            ? data.EndpointURL
            : `${data.EndpointURL.substr(0, 25)} ...`}
        </Typography>
        <Tooltip
          className={classes.tooltipSection}
          placement="right"
          title={data.EndpointURL}
          aria-label="EndpointURL">
          <ListItemIcon>
            <InfoOutlinedIcon />
          </ListItemIcon>
        </Tooltip>
      </div>
      <div>
        <Typography className={classes.text} align="left">
          {data.Status}
        </Typography>
      </div>
      <div className={classes.moreIcon}>
        <MonitoringRowMenu
          viewRequest={() => setviewRequestIsOpen(true)}
          viewResponse={() => setviewResponseIsopen(true)}
        />
      </div>
      <MonitoringFormViewMoreInfoModal
        requestView={JSON.parse(data.Request)}
        isOpen={viewRequestIsOpen}
        onClose={() => setviewRequestIsOpen(false)}
      />
      <MonitoringFormViewMoreInfoModal
        requestView={JSON.parse(data.Response)}
        isOpen={viewResponseIsopen}
        onClose={() => setviewResponseIsopen(false)}
      />
    </div>
  )
}
export default MonitoringFormListRowDesktop
